const T = require('prop-types');
const { default: Styled } = require('styled-components');
const ThemeManager = require('containers/ThemeManager');
const { theme } = require('styles/theme');

const Snackbar = require('../containers/Snackbar');
const FocusIndicator = require('components/FocusIndicator');
const DowntimeDialog = require('containers/DowntimeDialog');
const ForceAppUpgradeDialog = require('containers/ForceAppUpgradeDialog');

const { useAppSelector } = require('utils/redux');

const { context } = require('app-context');

const { selectors: { all: selectors } } = context;

const internals = {};

module.exports = function PlainLayout(props) {

    const {
        snackbarProps,
        children,
        ...rest
    } = props;

    const { Wrapper } = internals;

    return (
        <Wrapper
            onFocus={FocusIndicator.onFocusHandler} onBlur={FocusIndicator.onBlurHandler}
            {...rest}
        >
            <ThemeManager theme={theme}>
                {children}
                <FocusIndicator />
                <Snackbar {...snackbarProps} />
                <DowntimeDialog />
                <ForceAppUpgradeDialog />
            </ThemeManager>
        </Wrapper>
    );
};

module.exports.propTypes = {
    snackbarProps: T.object,
    children: T.element.isRequired
};

internals.Wrapper = Styled.div`
    height: 100%;

    *:focus {
        outline: none !important;
    }

    header {
        top: var(--safezonetop);
    }
`;
